.ux-password-input {
  display: block;
  position: relative;
  width: 100%;

  &__inner {
    background-color: var(--ux-input-background-color);
  }

  .ux-input {
    border: var(--ux-input-border-width) solid var(--ux-input-border-color);
    height: var(--ux-input-height);

    &:hover {
      background-color: var(--ux-input-hover-bg);
      border-color: var(--ux-input-hover-border-color);
    }

    &:hover:not(:focus) {
      color: var(--ux-input-hover-text-color);
    }

    &:active {
      background: var(--ux-input-active-bg);
      border-color: var(--ux-input-active-border-color);
      color: var(--ux-input-active-text-color);
    }

    &:focus {
      color: var(--ux-input-focus-text-color);
      outline: var(--ux-input-outline-width) solid var(--ux-input-focus-border-color);
      outline-offset: var(--ux-input-outline-offset);
    }

    &:disabled {
      background: var(--ux-input-disabled-bg);
      border-color: var(--ux-input-disabled-border-color);
      color: var(--ux-input-disabled-text-color);
      opacity: var(--ux-input-disabled-opacity);
    }

    &::placeholder {
      color: var(--ux-input-placeholder-color);
      font-weight: var(--ux-input-placeholder-font-weight);
    }
  }

  &--disabled {
    .ux-input {
      background-color: var(--ux-input-disabled-bg);
      border-color: var(--ux-input-disabled-border-color);
      color: var(--ux-input-disabled-text-color);
    }
  }

  &--error {
    .ux-input {
      border-color: var(--ux-input-error-border-color);
    }

    .ux-input:not(:disabled):not(:focus):hover {
      border-color: var(--ux-input-error-border-color);
    }
  }

  &[label] {
    .ux-password-input__toggle-visibility {
      display: block;
      height: 0;
      right: 0;
      top: 0;
    }

    input {
      padding-right: 20px;
    }
  }
}

.ux-password-input__input-wrapper {
  position: relative;
  width: 100%;

  &:first-of-type {
    margin-bottom: 30px;
  }

  &:only-of-type {
    margin-bottom: 0;
  }

  @media only screen and (min-width: $tablet) {
    &:first-of-type {
      margin-bottom: 0;
      margin-right: 15px;
    }

    &:last-of-type {
      margin-left: 15px;
    }

    &:only-of-type {
      margin: 0;
    }
  }

  label {
    width: calc(100% - 20px);
  }
}

.ux-password-input__toggle-visibility {
  align-items: center;
  background: transparent;
  border: 0;
  display: flex;
  height: 100%;
  padding: 0;
  position: absolute;
  right: 10px;
  top: 0;

  ux-icon {
    cursor: pointer;
    transition: fill 0.25s ease;
  }
}

.ux-password-input__toggle-visibility.active {
  ux-icon {
    fill: $color-green;
  }
}

.ux-input.ux-password-input__input {
  &--success {
    border-color: $color-green;
    color: $color-green;

    &:focus {
      border-color: $color-green;
    }
  }
}

.ux-password-input__tooltip-headline {
  @include font(bold);
  display: block;
  font-size: $size-text-small;
  margin-bottom: 10px;
  text-transform: uppercase;
}

.ux-password-input__tooltip-text {
  @include font(light);
  color: $color-gray-text;
  display: block;
  font-size: $size-text-small;
  margin-bottom: 5px;

  &:last-child {
    margin-bottom: 0;
  }

  &--is-valid {
    @include font(bold);
    color: $color-green;
  }
}
